import { useCallback, useMemo } from 'react';
import { startOfDay, addDays, max, addYears } from 'date-fns';
import { useIoContext } from "../../../../contexts";
export const useStartBillingDates = _ref => {
  let {
    relationshipEffectiveDate,
    isAmendedService
  } = _ref;
  const {
    getNow
  } = useIoContext();
  const getToday = useCallback(() => startOfDay(getNow()), []);
  const getTomorrow = useCallback(() => addDays(getToday(), 1), [getToday]);
  const getAmendedMinDate = useCallback(() => {
    const tomorrowDate = addDays(getToday(), 1);
    return relationshipEffectiveDate ? max([tomorrowDate, relationshipEffectiveDate]) : tomorrowDate;
  }, [getToday, relationshipEffectiveDate]);
  const amendedMinDate = useMemo(() => getAmendedMinDate(), [getAmendedMinDate]);
  const getInitialEffectiveDate = useCallback(() => {
    if (isAmendedService) {
      return getAmendedMinDate();
    }
    if (relationshipEffectiveDate) {
      return max([startOfDay(relationshipEffectiveDate), getToday()]);
    }
    return getTomorrow();
  }, [relationshipEffectiveDate, getToday, isAmendedService, getAmendedMinDate]);
  const getDraftMinDate = useCallback(() => {
    const tomorrowDate = getTomorrow();
    return relationshipEffectiveDate ? addYears(getToday(), -1) : tomorrowDate;
  }, [getTomorrow, getToday, relationshipEffectiveDate]);
  const draftMinDate = useMemo(() => getDraftMinDate(), [getDraftMinDate]);
  const minimumEffectiveDate = useMemo(() => isAmendedService ? amendedMinDate : draftMinDate, [isAmendedService, amendedMinDate, draftMinDate]);
  return {
    getToday,
    getTomorrow,
    minimumEffectiveDate,
    getInitialEffectiveDate
  };
};